import React from 'react';
import ContactComponent from '../components/Contact';
import { MapPin, Clock, Mail } from 'lucide-react';

const ContactPage = () => {
  return (
    <div>
      {/* Page Header */}
      <section className="bg-gradient-to-br from-[#D0E8F2] to-[#C4E5F4] py-16 px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-serif text-[#0A2540] font-bold mb-6">
            Get In Touch
          </h1>
          <p className="text-lg md:text-xl text-[#2C3E50] leading-relaxed">
            Ready to take control of your financial future? We're here to help you 
            every step of the way. Reach out today to schedule your free consultation.
          </p>
        </div>
      </section>

      {/* Contact Options */}
      <ContactComponent />

      {/* Additional Info Section */}
      <section className="bg-white py-20 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center space-y-4">
              <div className="flex justify-center">
                <div className="bg-[#C4E5F4] p-4 rounded-full">
                  <Clock className="h-8 w-8 text-[#0B8FD8]" />
                </div>
              </div>
              <h3 className="text-xl font-serif text-[#0A2540] font-bold">
                Office Hours
              </h3>
              <div className="text-[#2C3E50]">
                <p>Monday - Friday</p>
                <p className="font-semibold">9:00 AM - 6:00 PM</p>
                <p className="mt-2">Saturday</p>
                <p className="font-semibold">By Appointment</p>
              </div>
            </div>

            <div className="text-center space-y-4">
              <div className="flex justify-center">
                <div className="bg-[#C4E5F4] p-4 rounded-full">
                  <Mail className="h-8 w-8 text-[#0B8FD8]" />
                </div>
              </div>
              <h3 className="text-xl font-serif text-[#0A2540] font-bold">
                Email Us
              </h3>
              <div className="text-[#2C3E50]">
                <p>For general inquiries:</p>
                <a href="mailto:shannonbrooks@brooksassociatesllc.com" className="font-semibold text-[#0B8FD8] hover:underline">
                  shannonbrooks@brooksassociatesllc.com
                </a>
              </div>
            </div>

            <div className="text-center space-y-4">
              <div className="flex justify-center">
                <div className="bg-[#C4E5F4] p-4 rounded-full">
                  <MapPin className="h-8 w-8 text-[#0B8FD8]" />
                </div>
              </div>
              <h3 className="text-xl font-serif text-[#0A2540] font-bold">
                Service Area
              </h3>
              <div className="text-[#2C3E50]">
                <p>Serving clients nationwide</p>
                <p className="font-semibold">Virtual & In-Person</p>
                <p className="mt-2 text-sm">Consultations Available</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Teaser */}
      <section className="bg-gradient-to-br from-[#D0E8F2] to-[#C4E5F4] py-16 px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-serif text-[#0A2540] font-bold mb-6">
            Have Questions?
          </h2>
          <p className="text-lg text-[#2C3E50] mb-8">
            We're here to answer any questions you may have about our services, 
            pricing, or how we can help you achieve your financial goals.
          </p>
          <button
            onClick={() => window.open('https://go.sbrooksassociatesllc.com/bookwithshannon', '_blank')}
            className="bg-[#0B8FD8] hover:bg-[#0973B0] text-white px-8 py-3 text-base rounded-md transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Schedule a Free Consultation
          </button>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
